import { call, put, takeLatest } from 'redux-saga/effects'
import { notificationShow } from 'modules/Notifications/actions'
import {
  FETCH,
  SET,
  SET_LOADING,
} from 'modules/Recommendations/CampaignsRecommendations/Type/store/types'
import YD_RECOMMENDATIONS_API_V2 from 'api/recommendations/v2'

function* fetch({ payload }) {
  try {
    yield put({
      type: SET_LOADING,
      payload: { loading: true },
    })

    const { response, error } = yield call(
      YD_RECOMMENDATIONS_API_V2.fetchType,
      { networkType: 'yd', ...payload },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET,
      payload: {
        data: response.data.items,
        pagination: response.data.pagination,
      },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )
    console.logXHR(error)
  } finally {
    yield put({
      type: SET_LOADING,
      payload: { loading: false },
    })
  }
}

export default function* Sagas() {
  yield takeLatest(FETCH, fetch)
}
